import { RouterProvider } from "react-router-dom";
import "@/utils/i18n.utils.ts";
import { useAppRouter } from "@/Router.tsx";
import { Toaster } from "./components/ui/Sonner/Toaster";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const queryClient = new QueryClient();

function App() {
  const router = useAppRouter();
  return (
    <>
      <Toaster />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </>
  )
}

export default App
